import { Grid, Paper, Typography } from "@mui/material";

export default function ParameterItem({ item, data }) {
  const { label, renderer, size = 1, key } = item;
  // if()
  return (
    <Grid
      item
      xs={12}
      sm={6 * Math.min(2, size)}
      md={4 * Math.min(3, size)}
      lg={3 * Math.min(4, size)}
      xl={2 * Math.min(5, size)}
    >
      <Paper sx={{ p: 1,minHeight:120 }}>
        <Typography variant="h6" component="div">
          {typeof label === "function" ? label(data) : label}
        </Typography>
        <Typography variant="body1" component="div">
          {renderer ? renderer(data[key], data) : data[key]}
        </Typography>
      </Paper>
    </Grid>
  );
}